import en from '../../profileContent.en';

const footer = {
    ...en.footer,
    phoneLabel: 'Tél.',
    emailLabel: 'Email'
  };

export default footer;
